import { render } from "./errorPage.vue?vue&type=template&id=1d11d4d5&lang=true"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__